import "./chatBotMoga.css";
import moga from "../../assets/png/moga.png";

const ChatBothome = ({ setuserName, userName, setOpenChat }) => {
  return (
    <div className="chat-home-main">
      <div className="chat-home-head">
      <img loading="lazy"    src="/logo/National Games White Logo.png" alt="Logo" className="national-Logo" />
        <img loading="lazy" src={moga} alt="Logo" className="moga-Logo" />
        <h1> Need help?</h1>
      </div>
      <div className="chat-home-body">
        <input
          type="text"
          name="username"
          value={userName}
          placeholder="Enter your name"
          className="chatbot-home-username"
          onChange={(e) => {
            setuserName(e.target.value);
            setOpenChat(false);
          }}
        />
        <button
          type="submit"
          id="start-chat"
          className="chatbot-home-start"
          onClick={() => setOpenChat(true)}
        >
          Start
        </button>
      </div>
    </div>
  );
};

export default ChatBothome;
